import * as yup from 'yup';

export const getRequiredStringValidator = (
  fieldLabel?: string
): yup.StringSchema<string> => {
  return yup
    .string()
    .required(fieldLabel ? `${fieldLabel} is required.` : 'Required field');
};

export const getPasswordStringValidator = (
  fieldLabel?: string,
  isRequired = false
): yup.StringSchema<string | undefined> => {
  return isRequired
    ? yup
        .string()
        .min(
          6,
          `${fieldLabel || 'Password'} must be at least 6 characters in length.`
        )
        .max(
          20,
          `${fieldLabel || 'Password'} must be at most 20 characters in length.`
        )
        .required()
    : yup.string().optional();
};
export const getOptionalStringValidator = (): yup.StringSchema<
  string | undefined | null
> => {
  return yup.string().optional().nullable();
};
export const getRequiredNumberValidator = (
  fieldLabel?: string
): yup.NumberSchema<number> => {
  return yup
    .number()
    .typeError(`${fieldLabel ?? 'Field'} must be a number.`)
    .required(fieldLabel ? `${fieldLabel} is required.` : 'Required field');
};
